import React, { useState, useEffect, useRef } from "react";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import Carousel from "react-bootstrap/Carousel";
import Accordion from "react-bootstrap/Accordion";
import "./SinglesEvents.css";
import loader from '../../assests/loader.gif';
import API from '../../Utils/Api';
import {validatnew} from '../../Utils/validate';
import { gettoastsuccess,gettoastwarning } from '../../Utils/Common';
import Multiselect from "multiselect-react-dropdown";

const images = [
"assests/images/rrimg1.jpg",
"assests/images/rrimg2.jpg",
"assests/images/caro-slide1.jpg",
"assests/images/caro-slide2.jpg",
"assests/images/caro-slide3.jpg",
"assests/images/caro-slide4.jpg",
"assests/images/caro-slide5.jpg",
"assests/images/caro-slide6.jpg",
];

// const categories = [
// "Speed Dating",
// "Singles Socials",
// "Singles Run Club",
// "Wine Tasting",
// "Singles Weekend Getaway",
// "Dating Coaching & Workshops",
// ];

const SinglesEvents = () => {

const sliderRef = useRef(null);

const settings = {
dots: false,
infinite: true,
speed: 500,
slidesToShow: 1.2,
slidesToScroll: 1,
arrows: false,
autoplay: false,
centerMode: true,
centerPadding: '13%',
responsive: [
{
breakpoint: 768,
settings: {
slidesToShow: 1,
centerMode: true,
centerPadding: '0',
}
}
]
};

const [loading,setLoading] = useState(true);
const [inputsnew,setInputsnew] = useState({email:''});
const [errorsnew,setErrorsnew] = useState({});
const owlRef = useRef(null);
const [activeIndex, setActiveIndex] = useState(0);
const [category, setCategory] = useState([]);
const [events, setEvents] = useState([]);

const [categoryser, setCategoryser] = useState([]);
const [location, setLocation] = useState([]);
const [selected, setSelected] = useState([]);
const [selectedcat, setSelectedcat] = useState([]);

useEffect(() => {
// setTimeout(() => {
if (owlRef.current && owlRef.current.to) {
owlRef.current.to(activeIndex, 300);
}
// }, 100);
}, [activeIndex]);



const goToSlide = (index) => {
setActiveIndex(Math.max(0, Math.min(index, 5)));
};

const nextSlide = () => {
setActiveIndex((current) => (current + 1) % 6);
};

const prevSlide = () => {
setActiveIndex((current) => (current - 1 + 6) % 6);
};

const navigate = useNavigate();

// const [index, setIndex] = useState(0);

// const handleSelect = (selectedIndex) => {
// setIndex(selectedIndex);
// };

// const [isSliding, setIsSliding] = useState(false);

useEffect(() => {
window.scrollTo({
top: 0,
left: 0,
behavior: 'smooth',
});
document.title = `Singles Events | Your Friend My Friend`;
document.getElementById("bodywrap").className = "single sen-wrap";

/* Start get category data */
let formData = new FormData();
formData.append('type', 'home');
API.post('get_category',formData)
.then(response => {
setLoading(false);
if(response.data.status === false){

}else{
setCategory(response.data.data);
}
}).catch(error => {

});
/* End get category data */

/* Start get category data */
API.get('get_category')
.then(response => {
setLoading(false);
if(response.data.status === false){

}else{
const filteredData = response.data.data.map(item => ({
id: item.id,
name: item.name
}));
setCategoryser(filteredData);
}
}).catch(error => {

});
/* End get category data */

/* Start get location data */
API.get('get_location')
.then(response => {
if(response.data.status === false){

}else{
setLocation(response.data.data);
}
}).catch(error => {

});
/* End get location data */

/* Start get even data */
let formData1 = new FormData();
formData1.append('type', '');
API.post('get_events', formData1)
.then(response => {
setLoading(false);
if(response.data.status === false){

}else{
setEvents(response.data.data.event);
}
}).catch(error => {

});
/* End get even data */

}, []);

/* Start Value set */
const handleInputChangeNew = (event) => {
event.persist();
setInputsnew(inputsnew => ({...inputsnew, [event.target.name]: event.target.value}));
}
/* Start Submit */
const handleSubmitNew = () => {
const validationErrors = validatnew(inputsnew);
const noErrors = Object.keys(validationErrors).length === 0;
setErrorsnew({});
setErrorsnew(validationErrors);
if(noErrors){
setLoading(true);
let formData = new FormData();
formData.append('email', inputsnew.email);
API.post('newsletter', formData)
.then(response => {
if(response.data.status === false){
gettoastwarning(response.data.message,'');
setLoading(false);
}else{
setLoading(false);
setInputsnew({email:''});
gettoastsuccess(response.data.message,'');
}
}).catch(error => {
setLoading(false);
gettoastwarning('Something went wrong. Please try again later.','');
});
}
}


const handleInputChangeLoc = (selectedList) => {
//selectedList.persist();
setSelected(selectedList);

const allNewCat = [];
selectedcat.forEach((val) => {
allNewCat.push(val.id);
});

const allNewLoc = [];
selectedList.forEach((val) => {
allNewLoc.push(val.id);
});

let formData = new FormData();
formData.append('type', 'all');

formData.append('location_id', JSON.stringify(allNewLoc));


formData.append('category_id', JSON.stringify(allNewCat));

API.post('get_events', formData)
.then(response => {
setLoading(false);
if(response.data.status === false){

}else{
setEvents(response.data.data.event);
}
}).catch(error => {

});
}
const handleInputChangeCat = (selectedList) => {
//selectedList.persist();
setSelectedcat(selectedList);
console.log(selectedList);
const allNewCat = [];
selectedList.forEach((val) => {
allNewCat.push(val.id);
});

const allNewLoc = [];
selected.forEach((val) => {
allNewLoc.push(val.id);
});

let formData = new FormData();
formData.append('type', 'all');
formData.append('category_id', JSON.stringify(allNewCat));

formData.append('location_id', JSON.stringify(allNewLoc));

API.post('get_events', formData)
.then(response => {
setLoading(false);
if(response.data.status === false){

}else{
setEvents(response.data.data.event);
}
}).catch(error => {

});
}


const slides = [
  {
    title: "Large Singles Parties",
    description:
      "Our Large Singles Parties are some of Ireland's biggest singles events, bringing together 200 to 500 single professionals in Dublin and across Ireland. Optional icebreaker games get conversations started from the moment you arrive, making them a relaxed way to meet a lot of new people in one evening, whether you come alone or with friends. Every event has a balanced mix of men and women. Tickets often sell out within hours, so book early.",
    bigImage: "singles-party-big-1.jpg",
    smallImage: "singles-party-small-1.jpg",
  },
  {
    title: "Singles Quiz Night",
    description:
      "At our singles quiz nights, you're mixed into teams with people you haven't met before, with time between rounds to chat and get to know the people around you. It's a relaxed way to meet other singles without the pressure of a formal date, and there's always something to talk about. You don't need to be a quiz expert. Come on your own or bring a friend.",
    bigImage: "pub-quiz-big-1.jpg",
    smallImage: "pub-quiz-small-1.jpg",
  },
  {
    title: "Singles Comedy Night",
    description:
      "A night of live stand-up comedy for a room full of single people, followed by time to mingle at the bar. Laughing at the same jokes makes it easy to start a conversation, and the show gives you something to talk about straight away. Our singles comedy nights are a good choice if you want a fun night out that doesn't rely on small talk.",
    bigImage: "comedy-big-1.jpg",
    smallImage: "comedy-small-1.jpg",
  },
  {
    title: "Singles Wine Tasting",
    description:
      "Taste a selection of wines with a guide while getting to know other singles. You'll learn a bit about what's in your glass, and moving between tables and tastings means you'll meet plenty of people over the evening. No wine knowledge needed. A good fit if you prefer a slower-paced, more social alternative to a busy bar.",
    bigImage: "wine-tasting-large-1.jpg",
    smallImage: "wine-tasting-small-1.jpg",
  },
  {
    title: "Singles Supper Club",
    description:
      "Our Singles Supper Club is a sit-down dinner for single foodies, held in a different restaurant each month. Before the night, every guest completes a compatibility test, and we use the results to plan the seating so the people around you are potential matches. A full dinner gives you time for real conversation, making it ideal if you'd rather meet someone over a long meal than in a busy bar.",
    bigImage: "singles-supper-club-large-1.jpg",
    smallImage: "singles-supper-club-small-1.jpg",
  },
  {
    title: "Singles Weekend Getaway",
    description:
      "Spend a weekend away with other singles. Our singles getaways combine activities, meals and nights out over two or three days, so you get to know people properly rather than in a single evening. Most people come on their own, and the group gets to know each other quickly. Places are limited and sell out well in advance.",
    bigImage: "weekend-getaway-big-1.jpg",
    smallImage: "weekend-getaway-small-1.jpg",
  },
];

const activeSlide = slides[activeIndex];

return (
<>
  <Header />
  <div className="hello-worldss d-flex justify-content-center align-items-center">
    {/* Desktop Image */}
    <img src={process.env.REACT_APP_BASE_URL + 'assests/images/single-events-new.jpg' } alt="" className="img-fluid" />
  </div>

  <div className="container-fluid ireland sen-topbox">
    <div className="row g-4 justify-content-between">
      <div className="col-md-6 col-lg-4 ire-left">
        <p className="text-uppercase">Singles Events</p>
        <h1>
          Singles Events in Dublin and Across Ireland
        </h1>
      </div>

      <div className="col-md-6 col-lg-5 ire-right">
        <p>
          {" "}
          Meet other single people in person at Ireland's largest singles events company. Your Friend My Friend runs
          over 150 singles events a year in Dublin, Cork, Galway, Limerick and Belfast, for single professionals in
          their 20s to 50s.{" "}
        </p>
        <p>
          {" "}
          Choose from speed dating, large singles parties, curated singles parties, quiz nights, comedy nights, wine
          tastings, supper clubs, the Singles Run Club and weekend getaways. Every event is designed to make it easy to
          meet new people in a relaxed setting, whether you come on your own or with friends. No swiping, no algorithms,
          just real connections.{" "}
        </p>
        <p> Browse upcoming singles events near you and book your place. </p>
        <div className="arrive" onClick={()=> navigate("/upcoming-events")}>
          <Link to="/upcoming-events" className="btn bros-bu text-decoration-none">
          Browse Events
          </Link>
        </div>
      </div>
    </div>
  </div>


  <div className="container-fluid socis d-none d-md-block sen-slider-wrap">
    <div className="row">

      {/* LEFT COLUMN: Navigation + changing text */}
      <div className="col-md-5 d-flex align-items-start flex-column justify-content-between">
        <div>
        {/* Navigation stays outside the changing slide */}
        <div className="position-relative">
          <div className="col-12 d-flex flex-wrap gap-2 mb-5 top se-car-btn">
            {slides.map((slide, index) => (
              <Button
                key={slide.title}
                className={`btn ${
                  activeIndex === index ? "active-button" : ""
                }`}
                onClick={() => goToSlide(index)}
              >
                {slide.title}
              </Button>
            ))}
          </div>
        </div>

        {/* Only the text content changes */}
        <div className="col-12 mb-5 middle">
          <h2>{activeSlide.title}</h2>
          <p>{activeSlide.description}</p>
        </div>
</div>

    {/* Carousel dots */}
    <div>
      <div className="custom-carousel-dots">
        {slides.map((slide, index) => (
          <button
            key={slide.title}
            type="button"
            className={`custom-dot ${
              activeIndex === index ? "active" : ""
            }`}
            onClick={() => goToSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
            aria-current={activeIndex === index ? "true" : undefined}
          />
        ))}
      </div>
    </div>

      </div>

      {/* RIGHT COLUMN: Images + arrows stay outside the changing slide */}
      <div className="col-md-7 d-flex align-items-end justify-content-end gap-3">

        <div className="bigs">
          <img
            key={activeSlide.bigImage}
            src={`/assests/images/${activeSlide.bigImage}`}
            className="card-img-top"
            alt={activeSlide.alt}
          />
        </div>

        <div className="gvh se-slider-arrow">
          <div className="d-flex justify-content-start mb-3 jiui">

            <button
              type="button"
              className="btn p-0 me-3"
              onClick={prevSlide}
              aria-label="Previous slide"
            >
              <div className="arrow-container">
                <img
                  src="/assests/images/carousel-left.png"
                  className="img-fluid arrow-image arrow-image-1"
                  alt=""
                />
                <img
                  src="/assests/images/carousel-left-hover.png"
                  className="img-fluid arrow-image arrow-image-2"
                  alt=""
                />
              </div>
            </button>

            <button
              type="button"
              className="btn p-0"
              onClick={nextSlide}
              aria-label="Next slide"
            >
              <div className="arrow-container">
                <img
                  src="/assests/images/carousel-right.png"
                  className="img-fluid arrow-image arrow-image-1"
                  alt=""
                />
                <img
                  src="/assests/images/carousel-right-hover.png"
                  className="img-fluid arrow-image arrow-image-2"
                  alt=""
                />
              </div>
            </button>

          </div>

          <div className="smalls d-flex flex-column align-items-start">
            <div className="square-img-wrapper">
              <img
                key={activeSlide.smallImage}
                src={`/assests/images/${activeSlide.smallImage}`}
                className="card-img-top"
                alt={`${activeSlide.alt} thumbnail`}
              />
            </div>
          </div>
        </div>


      </div>
    </div>


  </div>




  <div className="container-fluid accors hello-iuyts d-md-none sen-acc-img">
    <div className="row">
      <div className="col-md-12">
        <Accordion>

          {/* Accordion 1: Speed Dating */}
          <Accordion.Item eventKey="0">
            <Accordion.Header>Large Singles Parties</Accordion.Header>
            <Accordion.Body>
              <p>
                Our Large Singles Parties are some of Ireland's biggest singles events, bringing together 200 to 500
                single professionals in Dublin and across Ireland. Optional icebreaker games get conversations started
                from the moment you arrive, making them a relaxed way to meet a lot of new people in one evening,
                whether you come alone or with friends. Every event has a balanced mix of men and women. Tickets often
                sell out within hours, so book early.
              </p>

              <div className="aco-topi mb-2 mt-3">
                <img src="/assests/images/singles-party-big-1.jpg" className="img-fluid" alt="Speed Dating" />
              </div>

              <div className="aco-boti">
                <img src="/assests/images/singles-party-small-1.jpg" className="img-fluid" alt="Speed Dating thumbnail" />
              </div>


            </Accordion.Body>
          </Accordion.Item>

          {/* Accordion 2: Singles Socials */}
          <Accordion.Item eventKey="1">
            <Accordion.Header>Singles Quiz Night</Accordion.Header>
            <Accordion.Body>
              <p>
                At our singles quiz nights, you're mixed into teams with people you haven't met before, with time
                between rounds to chat and get to know the people around you. It's a relaxed way to meet other singles
                without the pressure of a formal date, and there's always something to talk about. You don't need to be
                a quiz expert. Come on your own or bring a friend.
              </p>

              <div className="aco-topi mb-2 mt-3">
                <img src="/assests/images/pub-quiz-big-1.jpg" className="img-fluid" alt="Singles Socials" />
              </div>

              <div className="aco-boti">
                <img src="/assests/images/pub-quiz-small-1.jpg" className="img-fluid" alt="Singles Socials thumbnail" />
              </div>


            </Accordion.Body>
          </Accordion.Item>

          {/* Accordion 3: Singles Run Club */}
          <Accordion.Item eventKey="2">
            <Accordion.Header>Singles Comedy Night</Accordion.Header>
            <Accordion.Body>
              <p>
                A night of live stand-up comedy for a room full of single people, followed by time to mingle at the bar.
                Laughing at the same jokes makes it easy to start a conversation, and the show gives you something to
                talk about straight away. Our singles comedy nights are a good choice if you want a fun night out that
                doesn't rely on small talk.
              </p>

              <div className="aco-topi mb-2 mt-3">
                <img src="/assests/images/comedy-big-1.jpg" className="img-fluid" alt="Singles Run Club" />
              </div>

              <div className="aco-boti">
                <img src="/assests/images/comedy-small-1.jpg" className="img-fluid" alt="Singles Run Club thumbnail" />
              </div>


            </Accordion.Body>
          </Accordion.Item>

          {/* Accordion 4: Wine Tasting */}
          <Accordion.Item eventKey="3">
            <Accordion.Header>Singles Wine Tasting</Accordion.Header>
            <Accordion.Body>
              <p>
                Taste a selection of wines with a guide while getting to know other singles. You'll learn a bit about
                what's in your glass, and moving between tables and tastings means you'll meet plenty of people over the
                evening. No wine knowledge needed. A good fit if you prefer a slower-paced, more social alternative to a
                busy bar.
              </p>

              <div className="aco-topi mb-2 mt-3">
                <img src="/assests/images/wine-tasting-large-1.jpg" className="img-fluid" alt="Wine Tasting" />
              </div>

              <div className="aco-boti">
                <img src="/assests/images/wine-tasting-small-1.jpg" className="img-fluid" alt="Wine Tasting thumbnail" />
              </div>


            </Accordion.Body>
          </Accordion.Item>

          {/* Accordion 5: Singles Weekend Getaway */}
          <Accordion.Item eventKey="4">
            <Accordion.Header>Singles Supper Club</Accordion.Header>
            <Accordion.Body>
              <p>
                Our Singles Supper Club is a sit-down dinner for single foodies, held in a different restaurant each
                month. Before the night, every guest completes a compatibility test, and we use the results to plan the
                seating so the people around you are potential matches. A full dinner gives you time for real
                conversation, making it ideal if you'd rather meet someone over a long meal than in a busy bar.
              </p>

              <div className="aco-topi mb-2 mt-3">
                <img src="/assests/images/singles-supper-club-large-1.jpg" className="img-fluid" alt="Singles Weekend Getaway" />
              </div>

              <div className="aco-boti">
                <img src="/assests/images/singles-supper-club-small-1.jpg" className="img-fluid" alt="Weekend Getaway thumbnail" />
              </div>


            </Accordion.Body>
          </Accordion.Item>

          {/* Accordion 6: Dating Coaching & Workshops */}
          <Accordion.Item eventKey="5">
            <Accordion.Header>
              Singles Weekend Getaway
            </Accordion.Header>
            <Accordion.Body>
              <p>
                Spend a weekend away with other singles. Our singles getaways combine activities, meals and nights out
                over two or three days, so you get to know people properly rather than in a single evening. Most people
                come on their own, and the group gets to know each other quickly. Places are limited and sell out well
                in advance.
              </p>

              <div className="aco-topi mb-2 mt-3">
                <img src="/assests/images/weekend-getaway-big-1.jpg" className="img-fluid" alt="Dating Coaching and Workshops" />
              </div>

              <div className="aco-boti">
                <img src="/assests/images/weekend-getaway-small-1.jpg" className="img-fluid" alt="Dating Coaching thumbnail" />
              </div>


            </Accordion.Body>
          </Accordion.Item>

        </Accordion>
      </div>
    </div>
  </div>

  <div className="container-fluid sen-video">
    <div className="row">
      <div className="col-12">
        <video autoPlay muted loop playsInline controls>
          <source src={process.env.REACT_APP_BASE_URL + "assests/images/se-video.mp4" } type="video/mp4" />
        </video>
      </div>
    </div>
  </div>



  <div className="container-fluid expand new-expa sen-hiw">
    <div className="row align-items-strech d-flex">
      {/* Left Side Content */}
      <div className="col-md-6 d-flex flex-column justify-content-between">
        <div className="tired">
          <p>HOW IT WORKS</p>
          <h2>What to expect </h2>
        </div>
        <div className="tired-2">
          <Link to="/upcoming-events" className="brow-bu text-decoration-none d-none d-md-inline-block">
          BROWSE EVENTS
          </Link>
        </div>
      </div>

      {/* Right Side Features */}
      <div className="col-md-6 d-flex flex-column">
        <div className="d-flex flex-grow-1 gap-3 locat">
          <img src={ process.env.REACT_APP_BASE_URL + "assests/images/venu-1.png" } alt="Previous"
            className="img-fluid new" />
          <div>
            <h3>100-300 Singles in One Room </h3>
            <p>
              A vibrant mix of men and women, all looking to meet new
              people.{" "}
            </p>
          </div>
        </div>
        <div className="d-flex flex-grow-1 gap-3 locat">
          <img src={ process.env.REACT_APP_BASE_URL + "assests/images/venu-2.png" } alt="Previous"
            className="img-fluid new" />
          <div>
            <h3>A True Mingling Event</h3>
            <p>
              There’s no structured dating—it’s up to you to make the move
              and start a conversation.
            </p>
          </div>
        </div>
        <div className="d-flex flex-grow-1 gap-3 locat">
          <img src={ process.env.REACT_APP_BASE_URL + "assests/images/venu-3.png" } alt="Previous"
            className="img-fluid new" />
          <div>
            <h3>Fun Icebreakers </h3>
            <p>
              We'll provide a light, optional icebreaker to help get the
              conversations flowing, but ultimately, it’s your night to
              chat, connect, and have fun.
            </p>
          </div>
        </div>
        <div className="d-flex flex-grow-1 gap-3 locat locat">
          <img src={ process.env.REACT_APP_BASE_URL + "assests/images/venu-4.png" } alt="Previous"
            className="img-fluid new" />
          <div>
            <h3>Top Venues & Great Vibes </h3>
            <p>
              Hosted in some of Ireland’s best bars and venues, with a
              lively atmosphere perfect for meeting new people.
            </p>
          </div>
        </div>
        <div className="d-flex flex-grow-1 gap-3 locat locats">
          <img src={ process.env.REACT_APP_BASE_URL + "assests/images/pect-6.png" } alt="Previous"
            className="img-fluid new" />
          <div>
            <h3>No apps, no algorithms</h3>
            <p>
              just real people meeting face-to-face. Grab a drink, join the
              conversation, and make your move!
            </p>
          </div>
        </div>
      </div>


    </div>
  </div>



  <div className="container-fluid discover up-even sen-ue">
    <p className="text-center">UPCOMING EVENTS</p>
    <h2>Discover our events</h2>
    <div className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-3 filter d-none">
      <div className="col-12 col-md-auto files">Filter by</div>
      <div className="d-flex flex-column flex-md-row gap-2 alag">
        <div className="col-12 col-md-6 fil-name mb-2 mb-md-0">
          <Multiselect options={location} selectedValues={selected} onSelect={handleInputChangeLoc}
            onRemove={handleInputChangeLoc} displayValue="name" showCheckbox placeholder="Select Location" />
        </div>
        <div className="col-12 col-md-6 fil-name">
          <Multiselect options={categoryser} selectedValues={selectedcat} onSelect={handleInputChangeCat}
            onRemove={handleInputChangeCat} displayValue="name" showCheckbox placeholder="Select Type of Event" />
        </div>
      </div>
    </div>
    <div className="d-none d-md-flex row">
      {events.map((val, i) => (
      <div className="col-md-4 mb-4 joker sen-doe">
        <div className="card orama h-100 position-relative">
          <Link to={`/event-product/${val.id}`} className="text-decoration-none">
          <img src={val.event_image} className="card-img-top" alt={val.event_title} />
          </Link>
          <h5 className={`text-center event-cat-box${val.category_id}`}>{val.category_name}</h5>
          <div className="card-body d-flex flex-column">
            <div className="datesx">
              <div className="day-number">{val.day}</div>
              <div className="day-month">{val.month}</div>
            </div>

            <div className="d-flex gap-2 flex-wrap">
              {(() => {
              if (val.age_start==='' && val.age_end==='') {
              } else if (val.age_start!=='' && val.age_end==='') {
              return ( <h3>Age {val.age_start}+</h3>)
              }else if (val.age_start==='' && val.age_end!=='') {
              return ( <h3>Age {val.age_end}+</h3>)
              }else if (val.age_start!=='' && val.age_end!=='') {
              return ( <h3>Ages {val.age_start} - {val.age_end}</h3>)
              }
              })()}
              {val.tags.map((val1, index1) => {
              return (
              <h3>{val1}</h3>
              )
              })}
            </div>

            <Link to={`/event-product/${val.id}`} className="text-decoration-none">
            <h5>{val.event_title} {/*(Ages {val.age_start} - {val.age_end})*/}</h5>
            </Link>
            <p>{val.event_address}</p>

            <div className="mt-auto">
              <Link to={`/event-product/${val.id}`} className="text-decoration-none">
              <div className="get-ti">
                
                GET TICKETS
                
              </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
      ))}

    </div>

    <div className="d-block d-md-none">
      {category.length >0 &&(
      <Carousel className="p-0">
        {events.map((val, i) => (
        <Carousel.Item>
          <div className="card orama mx-2 position-relative joker sen-doe">
            <Link to={`/event-product/${val.id}`} className="text-decoration-none">
            <img src={val.event_image} className="card-img-top" alt={val.event_title} />
            </Link>
            <h5 className={`text-center event-cat-box${val.category_id}`}>{val.category_name}</h5>
            <div className="card-body">
              <div className="datesx">
                <div className="day-number">{val.day}</div>
                <div className="day-month">{val.month}</div>
              </div>

              {(() => {
              if (val.age_start==='' && val.age_end==='') {
              } else if (val.age_start!=='' && val.age_end==='') {
              return ( <h3>Age {val.age_start}</h3>)
              }else if (val.age_start==='' && val.age_end!=='') {
              return ( <h3>Age {val.age_end}</h3>)
              }else if (val.age_start!=='' && val.age_end!=='') {
              return ( <h3>Ages {val.age_start} - {val.age_end}</h3>)
              }
              })()}

              <Link to={`/event-product/${val.id}`} className="text-decoration-none">
              <h5>{val.event_title} {/*(Ages {val.age_start} - {val.age_end})*/}</h5>
              </Link>
              <p>{val.event_address}</p>

              <Link to={`/event-product/${val.id}`} className="text-decoration-none">
              <div className="get-ti sen-doe-btn">
                
                GET TICKETS

              </div>
              </Link>
            </div>
          </div>
        </Carousel.Item>
        ))}

      </Carousel>
      )}
    </div>

    <div className="text-center mt-4">
      <button className="btn sen-ble-btn" onClick={()=> navigate("/upcoming-events")}>
        BROWSE ALL EVENTS
      </button>
    </div>
  </div>

  <div className="container-fluid eventss">
    <div className="row g-3 align-items-stretch">
      <div className="col-md-4 img-col d-flex">
        <img src={process.env.REACT_APP_BASE_URL + 'assests/images/night.png' } alt="Event"
          className="img-fluid single" />
      </div>

      <div className="col-md-4 img-cols d-flex">
        <div className="testimonial-box">
          <div className="tes-1 flex-grow-1">
            <img src={process.env.REACT_APP_BASE_URL + 'assests/images/quote.png' } alt="Event" className="img-fluid" />
            <p>
              The singles night was so much fun with more opportunity to
              mingle and spend as much time chatting to people as you
              wanted. It was at the singles night I met a very lovely man
              who I have been happily dating for 4 weeks now.
            </p>
          </div>
          <div className="tes-2">
            <Link to="/about" className="btn text-decoration-none">
            VIEW SUCCESS STORIES
            </Link>
          </div>
        </div>
      </div>

      <div className="col-md-4 img-colss d-flex se-percentage">
        <div className="row w-100 flex-grow-1">
          <div className="col-12 d-flex flex-column">
            <div className="stats-box flex-grow-1 mb-3 d-flex flex-column justify-content-center">
              <h3>90%</h3>
              <p>
                of our event attendees say they have met someone they were interested at a YFMF event.
              </p>
            </div>
            <div className="stats-box flex-grow-1 mb-3 d-flex flex-column justify-content-center">
              <h3>85%</h3>
              <p>
                of singles who have attended a YFMF event have been on a date with someone they met at an event.
              </p>
            </div>
            <div className="stats-box flex-grow-1 d-flex flex-column justify-content-center">
              <h3>85%</h3>
              <p>made new friendships through YFMF events.</p>
            </div>
            <p className="mt-2 mb-0 sen-note">*Figures are based on a YFMF 2026 Community survey with 1,009 respondents.</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  {/* <div className="container-fluid real-connection">
    <div className="row">
      <div className="col-md-5 d-flex flex-column justify-content-between">
        <div className="slidees ols">
          <h6>YFMF</h6>
          <h2>Real people, real connections</h2>
        </div>
        <div className="d-none d-md-flex justify-content-start">
          <button className="btn" onClick={()=>
            setIndex(index === 0 ? images.length - 1 : index - 1)
            }
            >
            <div className="arrow-container">
              <img src={process.env.REACT_APP_BASE_URL + 'assests/images/carousel-left.png' }
                className="img-fluid arrow-image arrow-image-1" alt="Previous" />
              <img src={process.env.REACT_APP_BASE_URL + 'assests/images/carousel-left-hover.png' }
                className="img-fluid arrow-image arrow-image-2" alt="Previous Hover" />
            </div>
          </button>

          <button className="btn" onClick={()=>
            setIndex(index === images.length - 1 ? 0 : index + 1)
            }
            >
            <div className="arrow-container">
              <img src={process.env.REACT_APP_BASE_URL + 'assests/images/carousel-right.png' }
                className="img-fluid arrow-image arrow-image-1" alt="Next" />
              <img src={process.env.REACT_APP_BASE_URL + 'assests/images/carousel-right-hover.png' }
                className="img-fluid arrow-image arrow-image-2" alt="Next Hover" />
            </div>
          </button>
        </div>
      </div>

      <div className="col-md-1"></div>

      <div className="col-md-6 pe-md-0">
        <Carousel activeIndex={index} onSelect={handleSelect} indicators={false} controls={false} interval={null}
          wrap={true} slide={true} className={`custom-carousel pe-md-0 ${isSliding ? 'sliding' : '' }`} onSlide={()=>
          setIsSliding(true)}
          onSlid={() => setIsSliding(false)}
          >
          {images.concat(images[0]).map((img, i) => (
          <Carousel.Item key={i}>
            <div className="carousel-images">
              <img src={process.env.REACT_APP_BASE_URL + img} className="img-fluid main-img" alt={`Slide ${i}`} />
              {images[(i + 1) % images.length] && (
              <img src={process.env.REACT_APP_BASE_URL + images[(i + 1) % images.length]}
                className="img-fluid extra-img" alt={`Slide ${(i + 1) % images.length}`} />
              )}
            </div>
          </Carousel.Item>
          ))}
        </Carousel>
      </div>

      <div className="col-12 d-flex d-md-none justify-content-between mt-3 p-0">
        <button className="btn" onClick={()=>
          setIndex(index === 0 ? images.length - 1 : index - 1)
          }
          >
          <div className="arrow-container">
            <img src={process.env.REACT_APP_BASE_URL + 'assests/images/carousel-left.png' }
              className="img-fluid arrow-image arrow-image-1" alt="Previous" />
            <img src={process.env.REACT_APP_BASE_URL + 'assests/images/carousel-left-hover.png' }
              className="img-fluid arrow-image arrow-image-2" alt="Previous Hover" />
          </div>
        </button>
        <button className="btn" onClick={()=>
          setIndex(index === images.length - 1 ? 0 : index + 1)
          }
          >
          <div className="arrow-container">
            <img src={process.env.REACT_APP_BASE_URL + 'assests/images/carousel-right.png' }
              className="img-fluid arrow-image arrow-image-1" alt="Next" />
            <img src={process.env.REACT_APP_BASE_URL + 'assests/images/carousel-right-hover.png' }
              className="img-fluid arrow-image arrow-image-2" alt="Next Hover" />
          </div>
        </button>
      </div>
    </div>
  </div> */}

  <div className="container-fluid real-connection new-real">
    <div className="row justify-content-between">
      <div className="col-md-5 d-flex flex-column justify-content-between">
        <div className="slidees ols">
          <h6>YFMF</h6>
          <h2>Real people, real connections</h2>
        </div>
        <div className="d-none d-md-flex justify-content-start">
          <button className="btn" onClick={()=> sliderRef.current.slickPrev()}
            >
            <div className="arrow-container">
              <img src={ process.env.REACT_APP_BASE_URL + "assests/images/carousel-left.png" }
                className="img-fluid arrow-image arrow-image-1" alt="Previous" />
              <img src={ process.env.REACT_APP_BASE_URL + "assests/images/carousel-left-hover.png" }
                className="img-fluid arrow-image arrow-image-2" alt="Previous Hover" />
            </div>
          </button>
          <button className="btn" onClick={()=> sliderRef.current.slickNext()}
            >
            <div className="arrow-container">
              <img src={ process.env.REACT_APP_BASE_URL + "assests/images/carousel-right.png" }
                className="img-fluid arrow-image arrow-image-1" alt="Next" />
              <img src={ process.env.REACT_APP_BASE_URL + "assests/images/carousel-right-hover.png" }
                className="img-fluid arrow-image arrow-image-2" alt="Next Hover" />
            </div>
          </button>
        </div>
      </div>

      <div className="col-md-1"></div>

      <div className="col-md-6 pe-md-0">
        <div>
          <Slider ref={sliderRef} {...settings}>
            {images.map((img, i) => (
            <div key={i} className={`custom-slide ${i===images.length - 1 ? 'last-slide' : '' }`}>
              <img src={process.env.REACT_APP_BASE_URL + img} className="img-fluid respo" alt={`Slide ${i}`} style={{
                width: "100%" , height: "460px" , borderRadius: 24, objectFit: "cover" }} onError={(e)=>
              (e.target.style.display = "none")}
              />
            </div>
            ))}
          </Slider>
        </div>
      </div>

      <div className="col-12 d-flex d-md-none justify-content-between mt-3 p-0">
        <button className="btn vichi" onClick={()=> sliderRef.current.slickPrev()}
          >
          <div className="arrow-container">
            <img src={ process.env.REACT_APP_BASE_URL + "assests/images/carousel-left.png" }
              className="img-fluid arrow-image arrow-image-1" alt="Previous" />
            <img src={ process.env.REACT_APP_BASE_URL + "assests/images/carousel-left-hover.png" }
              className="img-fluid arrow-image arrow-image-2" alt="Previous Hover" />
          </div>
        </button>
        <button className="btn vichi" onClick={()=> sliderRef.current.slickNext()}
          >
          <div className="arrow-container">
            <img src={ process.env.REACT_APP_BASE_URL + "assests/images/carousel-right.png" }
              className="img-fluid arrow-image arrow-image-1" alt="Next" />
            <img src={ process.env.REACT_APP_BASE_URL + "assests/images/carousel-right-hover.png" }
              className="img-fluid arrow-image arrow-image-2" alt="Next Hover" />
          </div>
        </button>
      </div>
    </div>
  </div>

  <div className="container-fluid single-events d-none">
    <div className="row d-flex align-items-strech g-4">
      {/* Image Section */}
      <div className="col-md-7 od-1 d-flex">
        <img src={process.env.REACT_APP_BASE_URL + 'assests/images/single-event.png' } alt="Event Promo"
          className="img-fluid eve-img" />
      </div>

      {/* Text Section */}
      <div className="col-md-5 od-2 d-flex">
        <div className="get-app text-center d-flex flex-column align-items-center justify-content-center w-100">
          <h2>NEWSLETTER</h2>
          <h3>Keep me posted!</h3>
          <p>
            Be the first to know about upcoming Singles events near you.
          </p>
          <div className="d-flex mb-3 w-100">
            <div className="subscribe-box">
              <input type="text" name="email" value={inputsnew.email} placeholder="Your email address"
                className="form-control bg-transparent border-0" onChange={handleInputChangeNew} />
            </div>
            <button className="btn px-3" type="button" onClick={handleSubmitNew}>
              <img src={process.env.REACT_APP_BASE_URL + 'assests/images/another-right.svg' } alt="arrow"
                className="img-fluid" />
            </button>
          </div>
          {errorsnew.email && (<p className="text-danger mt-2 text-inherit-news">{errorsnew.email}</p>)}
          <p>*We respect your privacy and will never share your details.</p>
        </div>
      </div>
    </div>
  </div>

  <div className="conainer-fluid accors sen-faq">
    <div className="row">
      <div className="col-md-6">
        <p>FAQ</p>
        <h2>Frequently Asked Questions</h2>
      </div>
      <div className="col-md-6">
        <Accordion>
          <Accordion.Item eventKey="0">
            <h3 className="accordion-header">
              <Accordion.Button>
                What are Your Friend My Friend singles parties?
              </Accordion.Button>
            </h3>
            <Accordion.Body>
              Our singles parties are relaxed, in-person events for single people who want to meet face to face rather
              than through dating apps. They run in venues in Dublin, Cork, Galway, Limerick and Belfast, and range from
              large parties and summer BBQs to themed nights and smaller socials.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1">
            <h3 className="accordion-header">
              <Accordion.Button>
                How do Your Friend My Friend singles events work?
              </Accordion.Button>
            </h3>
            <Accordion.Body>
              Each event is a little different, but the aim is the same: to make it easier to meet people. After you
              book, you'll receive the full event details by email. On the night, our hosts welcome you and run some
              light icebreakers to get conversations started. After that, the evening is yours.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="2">
            <h3 className="accordion-header">
              <Accordion.Button>
                Where do you hold singles events?
              </Accordion.Button>
            </h3>
            <Accordion.Body>
              We run singles events in Dublin, Cork, Galway, Limerick and Belfast, plus weekend getaways in other parts
              of Ireland. Dublin has the most events, with something on most weeks. Browse upcoming events to see what's
              on in your city.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="3">
            <h3 className="accordion-header">
              <Accordion.Button>
                Who attends your singles events?
              </Accordion.Button>
            </h3>
            <Accordion.Body>
              Our events attract sociable single people from all walks of life. Most are working professionals in their
              20s to 50s. Some events are for specific age groups, and the age range is shown on the event listing. Most
              people who come are tired of swiping and would rather meet someone in person.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="4">
            <h3 className="accordion-header">
              <Accordion.Button>
                Do you have age-specific singles events?
              </Accordion.Button>
            </h3>
            <Accordion.Body>
              Yes. Many of our speed dating nights and some socials are for specific age ranges, such as 25 to 36 or 27
              to 38. The age range for each event is shown on its listing, so you can choose the one that suits you.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="5">
            <h3 className="accordion-header">
              <Accordion.Button>
                Do you run LGBTQ+ singles events?
              </Accordion.Button>
            </h3>
            <Accordion.Body>
              Yes. We run gay men's speed dating and lesbian speed dating in Dublin. Check our upcoming events for the
              latest LGBTQ+ dates.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="6">
            <h3 className="accordion-header">
              <Accordion.Button>
                Is there an even male to female ratio?
              </Accordion.Button>
            </h3>
            <Accordion.Body>
              We aim for a balanced gender ratio at every event, and we often close ticket sales for one gender if
              numbers become uneven. This keeps the event balanced for everyone attending.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="7">
            <h3 className="accordion-header">
              <Accordion.Button>
                Will I be matched with people at the event?
              </Accordion.Button>
            </h3>
            <Accordion.Body>
              At most singles parties you mingle freely, and there's no formal matchmaking. Some events, such as speed
              dating, curated singles parties and the Singles Supper Club, use a compatibility test to match you with
              people who suit you. Our team is always there to help with introductions.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="8">
            <h3 className="accordion-header">
              <Accordion.Button>
                What are curated singles parties?
              </Accordion.Button>
            </h3>
            <Accordion.Body>
              Curated singles parties have a hand-selected guest list. Every application is reviewed, and guests are
              chosen so that each person has as many potential matches in the room as possible.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="9">
            <h3 className="accordion-header">
              <Accordion.Button>
                How is a singles party different from speed dating?
              </Accordion.Button>
            </h3>
            <Accordion.Body>
              Singles parties are more relaxed and unstructured than speed dating. There are no timed conversations, so
              connections happen more naturally. If you'd prefer something structured where you're guaranteed to talk to
              everyone, speed dating is a good option. We run both.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="10">
            <h3 className="accordion-header">
              <Accordion.Button>
                What if I'm nervous about coming on my own?
              </Accordion.Button>
            </h3>
            <Accordion.Body>
              Most people come on their own, so you won't be the only one. Our hosts welcome everyone as they arrive and
              help with introductions, and the group setting makes it easy to join in.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="11">
            <h3 className="accordion-header">
              <Accordion.Button>
                Can I bring a friend?
              </Accordion.Button>
            </h3>
            <Accordion.Body>
              Yes. Many people come with a friend, and you can book tickets together. Coming with someone is a good way
              to feel more comfortable at your first event.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="12">
            <h3 className="accordion-header">
              <Accordion.Button>
                Do I have to take part in the icebreakers?
              </Accordion.Button>
            </h3>
            <Accordion.Body>
              No. Icebreakers are optional. Many people find them an easy way to start talking, but if you'd rather
              start conversations your own way, that's fine too.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="13">
            <h3 className="accordion-header">
              <Accordion.Button>
                What should I wear to a singles event?
              </Accordion.Button>
            </h3>
            <Accordion.Body>
              Smart casual is right for most of our events. For singles runs, outdoor events and weekend getaways, the
              event listing will tell you what to bring.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="14">
            <h3 className="accordion-header">
              <Accordion.Button>
                Are drinks included in the ticket?
              </Accordion.Button>
            </h3>
            <Accordion.Body>
              It depends on the event. Some tickets include a welcome drink, dinner or food, while others are entry
              only. Each event listing says exactly what's included.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="15">
            <h3 className="accordion-header">
              <Accordion.Button>
                How much do singles event tickets cost?
              </Accordion.Button>
            </h3>
            <Accordion.Body>
              Prices vary by event type and venue. The price is shown on each event listing, along with what's included.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="16">
            <h3 className="accordion-header">
              <Accordion.Button>
                How far in advance should I book?
              </Accordion.Button>
            </h3>
            <Accordion.Body>
              Most of our events sell out three weeks or more in advance, and our large singles parties can sell out
              within hours. Book early to get your place.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="17">
            <h3 className="accordion-header">
              <Accordion.Button>
                Do people actually meet someone at these events?
              </Accordion.Button>
            </h3>
            <Accordion.Body>
              Yes. Friendships, relationships, engagements and marriages have all come from our events, and a few babies
              have been born to couples who met at them. In our attendee survey, 82% met someone they were attracted to
              and over 70% went on a date.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="18">
            <h3 className="accordion-header">
              <Accordion.Button>
                How do I book a singles event?
              </Accordion.Button>
            </h3>
            <Accordion.Body>
              Go to yourfriendmyfriend.ie, browse upcoming events and choose the one that suits you. Once you've bought
              your ticket, you'll get a confirmation email with everything you need to know.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="19" className="hololast">
            <h3 className="accordion-header">
              <Accordion.Button>
                Are tickets refundable?
              </Accordion.Button>
            </h3>
            <Accordion.Body>
              Tickets are fully refundable up to 48 hours before the event. To cancel within 48 hours, email
              hello@yourfriendmyfriend.ie and we'll do our best to resell your ticket for you.
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
    </div>
  </div>
  {loading && (
  <div className="loadingClass">
    <img src={loader} alt="loader" />
  </div>
  )}
  <Footer />
</>
);
};

export default SinglesEvents;